import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router';
import { languageStore } from '../../subscriber/Language';
import SignatureDish from "./components/SignatureDish";
import HeroSection from '../../components/HeroSection';
import SeoHelmet from '../../components/SeoHelmet';
import staticBlogs from '../../data/blogs.json';
import Layout from "../layout";
// Import images
import heroImage from "../../assets/chef_luca_in_kitchen.png";

const Portfolio = () => {
    const location = useLocation();
    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('portfolio');

    // update the page title using Helmet
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    // 👇 SEO meta only from Home
    const seoPortfolio = staticBlogs.find(b => b.slug === 'portfolio');

    return (
        <Layout>
            <SeoHelmet
                title={seoPortfolio.name}
                description={seoPortfolio.sort_description}
                image={seoPortfolio.path}
                url={seoPortfolio.url}
            />
            <div className="bg-[#FFEDE1]">
                {/* Hero Section */}
                <HeroSection 
                    backgroundImage={heroImage}
                    title={t.title}
                />
                
                {/* Services Content */}
                {/* <section className="py-24 px-4 bg-[#fff]">
                    <div className="max-w-6xl mx-auto">
                        <div className="px-[17%]">
                            <h5 className="text-[#C7702A] font-jost text-base font-normal uppercase mb-2 text-center">{t.title}</h5>
                            <h2 className="text-[#1F0707] text-[45px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-center">{t.subtitle}</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {getArray(services).map((service, index) => (
                                <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg">
                                    <Link href={`/service_detail/${service?.slug}`} className="block">
                                        <Image 
                                            src={service?.image} 
                                            alt={service?.name} 
                                            width={300}
                                            height={200}
                                            className="w-full h-64 object-cover duration-300 hover:scale-105"
                                        />
                                        <div className="p-6">
                                            <h4 className="text-[#1F0707] font-['Libre_Caslon_Display',sans-serif] text-[28px] font-libre-caslon font-normal leading-[28.8px] mb-[6px] mt-0 text-size-adjust-100 unicode-bidi-isolate word-spacing-0">{service.name}</h4>
                                            <p className="text-[rgba(31,7,7,0.62)] font-['Jost',sans-serif] text-[14px] font-normal leading-[28.8px] mb-[14.4px] text-size-adjust-100 unicode-bidi-isolate">{service.sort_description}</p>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </section> */}

                {/* Booking Process */}
                {/* <section className="py-24 px-4 bg-[#FFEDE1]">
                    <div className="max-w-6xl mx-auto">
                        <h5 className="text-[#C7702A] font-jost text-base font-normal uppercase mb-2 text-left">{t.bookingProcess.title}</h5>
                        <h2 className="text-[#1F0707] text-[45px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-left">{t.bookingProcess.subtitle}</h2>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                            {getArray(t.bookingProcess.steps).map((step, index) => (
                                <div key={index} className="flex flex-col items-start">
                                    <div className="flex items-center w-full mb-4">
                                        <div className="bg-[#D3752B] text-white font-bold text-xl w-12 h-12 flex items-center justify-center">
                                            {step.number}
                                        </div>
                                        <div className="h-[1px] bg-[#D3752B] flex-grow mx-4 ml-8 mr-28 md:mr-28 lg:mr-8"></div>
                                    </div>
                                    <h2 className="text-[#1F0707] text-[28px] font-medium leading-[1.2em] tracking-[-0.015em] mb-12 font-libre-caslon text-left mb-2">{step.title}</h2>
                                    <p className="text-[rgba(31,7,7,0.62)] font-['Jost',sans-serif] text-[18px] font-normal leading-[28.8px] unicode-bidi-isolate">{step.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section> */}

                <SignatureDish t={t}/>
            </div>
        </Layout>
    );
};

export default observer(Portfolio);
